<template>
  <div id="app" class="fillcontain" style="height:100%" v-loading="upLoading2">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
        isRouterAlive:true,
    }
  },
  provide(){
    return{
        reload:this.reload
    }
  },
  computed:{
    upLoading2(){
      return this.$store.state.fullLoading
    },
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
          this.isRouterAlive = true
      })
    },
  }
  
}
</script>

<style lang="less">
	@import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue